import { render } from "./DistrictTrainee.vue?vue&type=template&id=7f2516ee&ts=true"
import script from "./DistrictTrainee.vue?vue&type=script&lang=ts"
export * from "./DistrictTrainee.vue?vue&type=script&lang=ts"

import "./DistrictTrainee.vue?vue&type=style&index=0&id=7f2516ee&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__